import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const SimpleBreadcrumb = (_param)=>{
    var { className , title , href  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "title",
        "href"
    ]);
    const classes = classnames('store-simple-breadcrumb-stores-v2', className);
    const children = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-left"
    }), title);
    return href ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({}, rest, {
        href: href,
        className: classes
    }), children) : /*#__PURE__*/ React.createElement("p", swcHelpers.extends({}, rest, {
        className: classes
    }), children);
};

export { SimpleBreadcrumb as default };
//# sourceMappingURL=SimpleBreadcrumb.js.map
